import React from 'react';
import styled from 'styled-components';
import Icon from './icons/index';

const StyledWrapper = styled.div`
  text-align: left;
  margin: 1rem auto;
`;
const QuoteWrapper = styled.div`
  width: 60px;
  svg {
    fill: var(--color-primary);
  }
  @media (max-width: 768px) {
    width: 47px;
  }
`;

const TestimonialContent = styled.div`
  padding-left: 2rem;
  margin: 1.2rem auto;
`;
const Message = styled.p`
  font-style: italic;
`;
const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: auto;
  margin: 1.6rem auto;
`;

const PersonImg = styled.img`
  margin: auto 1rem;
  border-radius: 50%;
  border: 1.5px solid var(--color-primary);
`;
const FooterMessage = styled.p``;

const Testimonial = ({ message, person_name, designation, img_src }) => {
  return (
    <StyledWrapper>
      <QuoteWrapper>
        <Icon iconName={'quote'} />
      </QuoteWrapper>
      <TestimonialContent>
        <Message>{message}</Message>

        <Footer>
          <picture>
            <PersonImg src={img_src} alt={person_name} width="52px" />
          </picture>
          <FooterMessage>
            {person_name}
            <br />
            {designation}
          </FooterMessage>
        </Footer>
      </TestimonialContent>
    </StyledWrapper>
  );
};
export default Testimonial;
